import { del, get, post } from './core';

export function followTournament(tournamentId: string): Promise<{ ok: boolean }> {
  return post(`/tournaments/${tournamentId}/follow`);
}

export function unfollowTournament(tournamentId: string): Promise<{ ok: boolean }> {
  return del(`/tournaments/${tournamentId}/follow`);
}

export function getMyFollow(tournamentId: string): Promise<{ following: boolean }> {
  return get(`/tournaments/${tournamentId}/my-follow`);
}
